import { MenuItemHover } from "./menu-item-hover";
import { ButtonMenu } from "./button-menu";
import { HeaderMenu } from "./header-menu";
import { HeaderLogo } from "./header-logo";
import EmitEvent, {
  HEADER_UPDATE_COLOR,
  PAGE_BEFORE_LEAVE,
  PAGE_ENTER,
  PAGE_LEAVE,
  PAGE_LOADED,
  SMOOTH_DISABLED,
  SMOOTH_ENABLED,
  UPDATE_PAGE_NAME,
} from "../../../libs/emit-event";
import { AnimationSimpleLine } from "../../animation/simple-line/simple-line";

export class Header {
  constructor() {
    this.DOM = { main: document.querySelector(".js-header") };
    this.DOM.headerName = this.DOM.main.querySelector(".js-header_pageName");
    this.menuItemHovers = [];
    this.isOpenMenu = false;
    this.init();
    this.bindEvent();
  }

  init() {
    const headerLogo = this.DOM.main.querySelector(".js-header_logo");
    this.DOM.main
      .querySelectorAll(".js-header_menu_main_list a")
      .forEach((item) => {
        this.menuItemHovers.push(
          new MenuItemHover({ el: item, onClick: this.onMenuClick.bind(this) })
        );
      });

    this.btnMenu = new ButtonMenu({
      el: this.DOM.main.querySelector(".js-header_btnMenu_btn"),
      onClick: this.toggleMenu.bind(this),
    });
    this.headerMenu = new HeaderMenu({
      el: this.DOM.main.querySelector(".js-header_menu"),
      onClose: () => this.btnMenu.eventClick(),
      headerLogo,
    });
    this.headerLogo = new HeaderLogo({ el: headerLogo, header: this.DOM.main });
    this.animationHeaderName = new AnimationSimpleLine(this.DOM.headerName);
  }

  toggleMenu() {
    if (this.isOpenMenu) {
      this.DOM.main.classList.remove("is-open");
      this.headerMenu.closeMenu();
    } else {
      this.headerMenu.openMenu();
      this.DOM.main.classList.add("is-open");
    }

    this.isOpenMenu = !this.isOpenMenu;
  }

  menuClose() {
    this.menuItemHovers.forEach((item) => {
      setTimeout(() => {
        item.lineOut();
      }, 800);
    });
  }

  onMenuClick() {
    this.menuItemHovers.forEach((item) => {
      item.isActive && item.lineAnimationLeave();
    });
  }

  pageLoaded() {
    this.DOM.main.classList.add("is-show");

    if (document.body.classList.contains("product-template-default")) {
      this.DOM.main.classList.add("is-white");
    } else {
      this.DOM.main.classList.remove("is-white");
    }
  }

  pageEnter() {
    if (
      !document.body.classList.contains("home") &&
      !document.body.classList.contains("product-template-default") &&
      !document.body.classList.contains("news-template-default")
    ) {
      this.animationHeaderName.animationIn();
    }
  }

  pageBeforeLeave() {
    this.animationHeaderName.animationOut();
    this.isOpenMenu && this.btnMenu.eventClick();
    this.DOM.main.classList.remove("is-white");
  }

  updateHeaderName({ pageName = "" }) {
    this.animationHeaderName.DOM.elemntMask.innerHTML = pageName;
  }

  updateColor({ color }) {
    if (color === "white") {
      this.DOM.main.classList.add("is-white");
    } else {
      this.DOM.main.classList.remove("is-white");
    }
  }

  bindEvent() {
    EmitEvent.on(PAGE_ENTER, this.pageEnter.bind(this));
    EmitEvent.on(PAGE_BEFORE_LEAVE, this.pageBeforeLeave.bind(this));
    EmitEvent.on(PAGE_LOADED, this.pageLoaded.bind(this));
    EmitEvent.on(SMOOTH_ENABLED, this.menuClose.bind(this));
    EmitEvent.on(UPDATE_PAGE_NAME, this.updateHeaderName.bind(this));
    EmitEvent.on(HEADER_UPDATE_COLOR, this.updateColor.bind(this));
  }
}
